var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVector30 = function SvgVector30(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#001D53",
    d: "M8 18.773 2.697 13.47a7.5 7.5 0 1 1 10.606 0zm4.125-6.481a5.832 5.832 0 1 0-8.25 0L8 16.417zM8 9.833A1.667 1.667 0 1 1 8 6.5a1.667 1.667 0 0 1 0 3.333"
  })));
};
export default SvgVector30;